import ContentMedia from './ContentMedia.vue'

export default ContentMedia
